<template>
  <div class="login-component-block">
    <div class="login-component-block__login-gap">
      <div class="login-component-block__login-gap__title">
        {{ isSignUp ? "Sign Up" : "Log In" }}
      </div>
      <div class="login-component-block__login-gap__subtitle">
        {{ isSignUp ? "Already have an account? " : `Don’t have an account? ` }}
        <span
          class="href-row"
          @click="
            () => {
              isSignUp = !isSignUp;
            }
          "
          >{{ isSignUp ? "Log In" : "Sign Up" }}</span
        >
      </div>
      <div class="login-component-block__login-gap__buttons">
        <div
          class="login-component-block__login-gap__buttons__button _facebook"
          @click="loginByFacebook"
        >
          <div class="icon"></div>
          {{ isSignUp ? "Sign up with Facebook" : "Log in with Facebook" }}
        </div>
        <div
          class="login-component-block__login-gap__buttons__button _google"
          @click="loginByGoogle"
        >
          <div class="icon"></div>
          {{ isSignUp ? "Sign up with Google" : "Log in with Google" }}
        </div>
      </div>

      <div class="login-component-block__login-gap__footer-message">
        <div
          class="row-labled-checkbox"
          style="margin-left: 5px; align-items: center"
        >
          <BaseCheckbox
            v-model="agreeWithTerms"
            style="margin-right: 10px; opacity: 0.5"
          ></BaseCheckbox
          >{{ `By signing up, you agree to our ` }}
          <span class="href-row" @click="openTerms">terms of service</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/app/store/index";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";

export default {
  name: "Login",
  components: { BaseCheckbox },
  data: function () {
    return {
      isSignUp: true,
      agreeWithTerms: true,
    };
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      let ymUID = this.$cookies.get("_ym_uid");
      this.axios
        .post(
          "/user/getUser",
          { sessionId: this.$store.state.userInfo.sessionId, ymUID: ymUID },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.$store.state.userInfo.id = response.data.id;
          this.$store.state.userInfo.firstName = response.data.firstName;
          this.$store.state.userInfo.lastName = response.data.lastName;
          this.$store.state.userInfo.avatar = response.data.avatar;
          this.$store.state.userInfo.stockAccess = response.data.stockAccess;
          this.$store.state.userInfo.isSaveOriginalName =
            response.data.originalName;
          this.$router.push("/");
        })
        .catch((erorr) => {
          console.error(erorr);
          this.$store.state.userInfo.sessionId = null;
          this.$router.push("/login");
        });
    }
  },
  methods: {
    localLogin() {
      const token = "029e1283c6eda50a78420edea6f3da2f";
      this.$store.state.userInfo.sessionId = token;
      this.$cookies.set("sessionId", token);
      this.$router.push("/");
    },
    loginByFacebook() {
      if (!this.checkTermsAgree()) {
        return;
      }
      if (this.$buildType === "local") {
        this.localLogin();
        return;
      }
      let facebookDevAuthUrl = `https://www.facebook.com/dialog/oauth?client_id=605758379617541&redirect_uri=https://rsz-dev.roasup.com/auth/fbdev.php&scope=email&response_type=code`;
      let facebookProdAuthUrl = `https://www.facebook.com/dialog/oauth?client_id=605758379617541&redirect_uri=https://creative.roasup.com/auth/fbcreative.php&scope=email&response_type=code`;
      window.location =
        this.$buildType === "development"
          ? facebookDevAuthUrl
          : facebookProdAuthUrl;
    },
    loginByGoogle() {
      if (!this.checkTermsAgree()) {
        return;
      }
      if (this.$buildType === "local") {
        this.localLogin();
        return;
      }
      let googleDevAuthUrl = `https://accounts.google.com/o/oauth2/auth?client_id=875943351251-v5phn9mv4mgnvhhue970ea3lg6d923rh.apps.googleusercontent.com&redirect_uri=https://rsz-dev.roasup.com/auth/google-dev.php&response_type=code&scope=https://www.googleapis.com/auth/userinfo.email%20https://www.googleapis.com/auth/userinfo.profile`;
      let googleProdAuthUrl = `https://accounts.google.com/o/oauth2/auth?client_id=600674349104-d7pnc2l0mmlp4j7ughs3lnf7032v8vo5.apps.googleusercontent.com&redirect_uri=https://creative.roasup.com/auth/google.php&response_type=code&scope=https://www.googleapis.com/auth/userinfo.email%20https://www.googleapis.com/auth/userinfo.profile`;
      window.location =
        this.$buildType === "development"
          ? googleDevAuthUrl
          : googleProdAuthUrl;
    },
    checkTermsAgree() {
      if (!this.agreeWithTerms) {
        alert("You must agree to our terms of service");
      }
      return this.agreeWithTerms;
    },
    openTerms() {
      let termsUrl = `https://roasup.com/terms.html`;
      window.open(termsUrl);
    },
  },
};
</script>

<style lang="scss">
.login-component-block {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 200%;

  .logo {
    width: 250px;
  }

  .logo svg path {
    fill: red !important;
  }

  &__login-gap {
    width: 484px;
    height: 360px;
    background: $color-gray-3;
    border: 1px solid $color-gray-5;
    box-sizing: border-box;
    border-radius: 8px;
    padding-top: 56px;
    display: flex;
    flex-direction: column;

    &__title {
      width: 100%;

      user-select: none;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;

      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-feature-settings: "ss04" on;

      color: $color-font-basic;
    }

    &__subtitle {
      width: 100%;
      padding-top: 12px;

      user-select: none;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 120%;

      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      color: $color-font-basic;
      white-space: pre;
    }

    &__buttons {
      width: 100%;
      padding-top: 42px;

      user-select: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;

      &__button {
        position: relative;
        width: 298px;
        height: 36px;

        user-select: none;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        text-align: center;

        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 18px;

        background-color: $color-gray-4;
        border-radius: 4px;

        cursor: pointer;

        &:hover {
          background-color: $color-gray-5;
        }

        &._facebook {
          .icon {
            position: absolute;
            left: 9px;
            height: 16px;
            width: 16px;
            background-image: url("~assets/new-icons/facebook-icon.svg");
            background-size: cover;
            background-repeat: no-repeat;
          }
        }

        &._google {
          margin-top: 17px;
          .icon {
            position: absolute;
            left: 9px;
            height: 16px;
            width: 16px;
            background-image: url("~assets/new-icons/google-icon.svg");
            background-size: cover;
            background-repeat: no-repeat;
          }
        }
      }
    }

    &__footer-message {
      width: 100%;
      padding-top: 22px;

      user-select: none;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 16px;

      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      color: $color-gray-7;
      white-space: pre;
    }
  }
}
</style>
